// PDF condivisibile del risultato copertura (jsPDF, vettoriale): intestazione app + mini-mappa
// OpenStreetMap dell'indirizzo + dati copertura. Usato dal link desktop (matrice SalesMate) e
// dalla PWA agente (matrice SalesMate + risultato del sito TIM).
// Tutto best-effort: logo e mappa sono opzionali, il PDF si genera comunque.

// ── canvas: helper di disegno ──
function loadImg(src) {
  return new Promise((res, rej) => { const im = new Image(); im.onload = () => res(im); im.onerror = rej; im.src = src; });
}
function rr(ctx, x, y, w, h, r) {
  ctx.beginPath(); ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}
// Riproduce il logo "S" dell'app (badge con gradiente conico arancio->vino->blu + S sfumata) come PNG.
function appLogoDataUrl() {
  try {
    const s = 128, cv = document.createElement('canvas'); cv.width = s; cv.height = s;
    const ctx = cv.getContext('2d');
    if (!ctx || !ctx.createConicGradient) return null;
    const g = ctx.createConicGradient(210 * Math.PI / 180, s / 2, s / 2);
    g.addColorStop(0, '#e59500'); g.addColorStop(0.34, '#b3184f'); g.addColorStop(0.67, '#3283bd'); g.addColorStop(1, '#e59500');
    rr(ctx, 0, 0, s, s, s * 0.28); ctx.fillStyle = g; ctx.fill();
    const p = s * 0.06; rr(ctx, p, p, s - 2 * p, s - 2 * p, s * 0.22); ctx.fillStyle = '#0b1122'; ctx.fill();
    const lg = ctx.createLinearGradient(0, 0, s, 0); lg.addColorStop(0, '#e59500'); lg.addColorStop(1, '#b3184f');
    ctx.fillStyle = lg; ctx.font = `800 ${Math.round(s * 0.5)}px Segoe UI, Arial, sans-serif`;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('S', s / 2, s * 0.56);
    return cv.toDataURL('image/png');
  } catch (e) { return null; }
}
function drawCheck(doc, x, y) {
  doc.setDrawColor(22, 163, 74); doc.setLineWidth(0.7);
  doc.lines([[0.9, 1.0], [1.9, -2.4]], x, y);   // spunta verde (vettoriale)
}

// ── Mini-mappa del quartiere con la via segnata (OpenStreetMap, gratis, best-effort) ──
const lon2t = (lon, z) => (lon + 180) / 360 * Math.pow(2, z);
const lat2t = (lat, z) => { const r = lat * Math.PI / 180; return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * Math.pow(2, z); };
// Timeout esplicito: senza, su rete pessima/captive portal la promise resta appesa per sempre
// e il pulsante "Condividi PDF" non si abilita mai (la mappa e' opzionale, meglio rinunciarci).
const conTimeout = (p, ms) => Promise.race([p, new Promise((res) => setTimeout(() => res(null), ms))]);
// Cache per indirizzo: scorrere la cronologia non deve rifare geocode/tile ogni volta
// (Nominatim ammette ~1 richiesta al secondo) ne' consumare dati mobili inutilmente.
const cacheMappa = new Map();
async function geocode(q) {
  try {
    const opt = { headers: { Accept: 'application/json' } };
    if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) opt.signal = AbortSignal.timeout(6000);
    const r = await fetch('https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=it&q=' + encodeURIComponent(q), opt);
    const j = await r.json();
    if (j && j[0]) return { lat: parseFloat(j[0].lat), lon: parseFloat(j[0].lon) };
  } catch (e) { /* offline / rate-limit / timeout */ }
  return null;
}
async function mappaVia(indirizzo) {
  const pt = await conTimeout(geocode(indirizzo), 7000);
  if (!pt) return null;
  const z = 16, TS = 256, W = 640, H = 224;
  const cx = lon2t(pt.lon, z), cy = lat2t(pt.lat, z), x0 = Math.floor(cx), y0 = Math.floor(cy);
  const cvW = W / 2, cvH = H / 2;
  const load = (tx, ty, px, py) => new Promise((res) => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => res({ im, px, py }); im.onerror = () => res(null);
    im.src = `https://tile.openstreetmap.org/${z}/${tx}/${ty}.png`;
  });
  const jobs = [];
  for (let dx = -3; dx <= 3; dx++) {
    const px = cvW + (x0 + dx - cx) * TS; if (px >= W || px + TS <= 0) continue;
    for (let dy = -3; dy <= 3; dy++) {
      const py = cvH + (y0 + dy - cy) * TS; if (py >= H || py + TS <= 0) continue;
      jobs.push(load(x0 + dx, y0 + dy, px, py));
    }
  }
  const tiles = (await conTimeout(Promise.all(jobs), 8000)) || [];
  if (!tiles.some(Boolean)) return null;
  try {
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');
    ctx.fillStyle = '#e8ecf1'; ctx.fillRect(0, 0, W, H);
    tiles.forEach((t) => { if (t) ctx.drawImage(t.im, t.px, t.py, TS, TS); });
    // pin sulla via (goccia + cerchio)
    const mx = cvW, my = cvH;
    ctx.fillStyle = '#c81e5c'; ctx.strokeStyle = '#fff'; ctx.lineWidth = 2.5;
    ctx.beginPath(); ctx.arc(mx, my - 15, 10, Math.PI * 0.72, Math.PI * 0.28); ctx.lineTo(mx, my + 2); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.arc(mx, my - 16, 10, 0, 2 * Math.PI); ctx.fill(); ctx.stroke();
    ctx.beginPath(); ctx.arc(mx, my - 16, 4, 0, 2 * Math.PI); ctx.fillStyle = '#fff'; ctx.fill();
    // attribuzione OSM (obbligatoria)
    ctx.font = '10px Arial'; ctx.textAlign = 'right'; ctx.textBaseline = 'bottom';
    ctx.fillStyle = 'rgba(255,255,255,.75)'; ctx.fillRect(W - 122, H - 14, 122, 14);
    ctx.fillStyle = '#444'; ctx.fillText('© OpenStreetMap', W - 3, H - 2);
    return cv.toDataURL('image/jpeg', 0.72);
  } catch (e) { return null; }   // canvas "tainted" (tile senza CORS) -> niente mappa
}

// ── impaginazione comune ──
const M = 15, R = 195;
export const covIndirizzoTxt = (a) => {
  if (!a) return '';
  if (typeof a === 'string') return a;
  return `${a.via || a.indirizzo || ''} ${a.civico || ''}${a.comune ? ' · ' + a.comune : ''}`.replace(/\s+/g, ' ').trim();
};
// Query per il geocoder: dall'indirizzo (stringa o oggetto) al testo "via civico, comune, provincia".
const queryIndirizzo = (a) => {
  if (!a) return '';
  if (typeof a === 'string') return a;
  return [`${a.via || a.indirizzo || ''} ${a.civico || ''}`.trim(), a.comune, a.provincia].filter(Boolean).join(', ');
};
// Mappa con cache per indirizzo (anche i fallimenti, per non ritentare in raffica).
async function mappaCached(q) {
  if (cacheMappa.has(q)) return cacheMappa.get(q);
  const url = await mappaVia(q);
  cacheMappa.set(q, url);
  return url;
}

// `geoAddr` (opzionale) e' l'indirizzo da usare per la mappa quando diverso da quello mostrato:
// serve per non geocodificare forme abbreviate tipo "V. ROMA, 5, MILANO (MI)" (match sbagliati).
async function intestazione(doc, indirizzo, utente, geoAddr) {
  let y = 20, tx = M;
  const applogo = appLogoDataUrl();
  if (applogo) { doc.addImage(applogo, 'PNG', M, y - 6.4, 11, 11); tx = M + 14; }
  doc.setFont('helvetica', 'bold'); doc.setFontSize(15); doc.setTextColor(12, 32, 54);
  doc.text('Centro Verifiche', tx, y);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(107, 116, 134);
  doc.text('Verifica copertura di rete', tx, y + 5.5);
  try { const img = await loadImg('/logo-sonitech.jpg'); const lw = 30, lh = lw * (img.naturalHeight / img.naturalWidth); doc.addImage(img, 'JPEG', R - lw, y - 4.5, lw, lh); } catch (e) { /* logo opzionale */ }
  y += 9;
  doc.setDrawColor(12, 32, 54); doc.setLineWidth(0.6); doc.line(M, y, R, y);
  y += 13;
  doc.setFillColor(47, 109, 158); doc.roundedRect(M, y - 5, 1.8, 7, 0.9, 0.9, 'F');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(17); doc.setTextColor(12, 32, 54);
  doc.text('Analisi Copertura', M + 4.5, y);
  y += 6;
  doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(107, 116, 134);
  const meta = [covIndirizzoTxt(indirizzo) || '—', new Date().toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' })];
  if (utente) meta.push('Richiesto da ' + utente);
  doc.text(meta.join('   ·   '), M, y);
  y += 8;
  // Mini-mappa del quartiere con la via segnata (best-effort: se non c'e', si salta senza appesantire)
  try {
    const q = queryIndirizzo(geoAddr === undefined ? indirizzo : geoAddr);
    const mapUrl = q ? await mappaCached(q) : null;
    if (mapUrl) {
      const mw = R - M, mh = mw * 224 / 640;
      doc.addImage(mapUrl, 'JPEG', M, y, mw, mh);
      doc.setDrawColor(214, 222, 232); doc.setLineWidth(0.3); doc.roundedRect(M, y, mw, mh, 1.5, 1.5, 'S');
      y += mh + 8;
    }
  } catch (e) { /* mappa opzionale */ }
  return y;
}

function chiudi(doc, nome) {
  doc.setDrawColor(238, 241, 245); doc.setLineWidth(0.2); doc.line(M, 285, R, 285);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(154, 163, 178);
  doc.text('Documento generato automaticamente', M, 290);
  doc.text('soni-tech.it', R, 290, { align: 'right' });
  return new File([doc.output('blob')], nome, { type: 'application/pdf' });
}

// Riga "etichetta ..... valore" con spunta verde.
function riga(doc, y, label, valore) {
  drawCheck(doc, M + 2, y - 1.5);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(27, 37, 54);
  doc.text(label, M + 8, y);
  doc.setFontSize(10); doc.setTextColor(59, 70, 88);
  doc.text(String(valore), R, y, { align: 'right' });
  doc.setDrawColor(238, 241, 245); doc.setLineWidth(0.2); doc.line(M, y + 2.6, R, y + 2.6);
}

function titoloGruppo(doc, y, testo) {
  doc.setFillColor(238, 244, 251); doc.setDrawColor(214, 228, 242); doc.setLineWidth(0.2);
  doc.roundedRect(M, y, R - M, 7, 1.5, 1.5, 'FD');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.setTextColor(47, 109, 158);
  doc.text(testo, M + 3, y + 4.7);
}

/**
 * PDF della copertura SalesMate (matrice a colonne).
 * @param d risultato { indirizzo, colonne, esito }
 * @param utente nome di chi ha richiesto la verifica
 * @param opts { colonne (gia' risolte dal chiamante: le verifiche vecchie non hanno `colonne` e
 *               vanno ricostruite dall'esito), gruppi: [{id, keys}], label: {key: etichetta},
 *               valore: (key, cella) => string }
 */
export async function makeCoperturaPdf(d, utente, opts = {}) {
  const { colonne = {}, gruppi = [], label = {}, valore = () => 'Disponibile' } = opts;
  const { jsPDF } = await import('jspdf');   // chunk separato: non appesantisce il bundle
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  let y = await intestazione(doc, d.indirizzo, utente);
  const groups = gruppi.map((g) => ({ id: g.id, keys: g.keys.filter((k) => (colonne[k] || {}).esito === 'OK') })).filter((g) => g.keys.length);
  if (!groups.length) {
    doc.setTextColor(107, 116, 134); doc.setFontSize(11);
    doc.text('Nessuna tecnologia vendibile su questo indirizzo.', M, y + 3);
  }
  groups.forEach((g) => {
    if (y > 270) { doc.addPage(); y = 20; }
    titoloGruppo(doc, y, g.id);
    y += 11;
    g.keys.forEach((k) => {
      if (y > 282) { doc.addPage(); y = 20; }
      riga(doc, y, label[k] || k, valore(k, colonne[k]));
      y += 7;
    });
    y += 3.5;
  });
  return chiudi(doc, 'analisi-copertura.pdf');
}

// Mbps -> etichetta leggibile (>=1000 in Gbit/s).
export const fmtVel = (mbps) => {
  if (mbps == null || mbps === '') return null;
  const n = Number(mbps);
  if (!isFinite(n)) return String(mbps);
  return n >= 1000 ? `${(n / 1000).toLocaleString('it-IT')} Gbit/s` : `${n.toLocaleString('it-IT')} Mbps`;
};

/**
 * PDF della copertura verificata sul sito TIM.
 * @param res { esito, tecnologia, down, up, latenza, indirizzo_norm, raw }
 * @param utente nome di chi ha richiesto la verifica
 * @param indirizzo indirizzo cercato (stringa o { comune, via/indirizzo, civico, provincia })
 */
export async function makeCoperturaTimPdf(res, utente, indirizzo) {
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  // mappa solo dall'indirizzo strutturato: `indirizzo_norm` e' abbreviato e geocodifica male
  let y = await intestazione(doc, indirizzo || res.indirizzo_norm, utente, indirizzo || null);
  const coperto = (res.esito || '').toUpperCase() === 'COPERTO';
  // Esito in evidenza (verde se coperto, ambra altrimenti): niente viola/indaco.
  if (coperto) doc.setFillColor(34, 197, 94); else doc.setFillColor(245, 158, 11);
  doc.roundedRect(M, y, R - M, 11, 2, 2, 'F');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(255, 255, 255);
  doc.text(`${res.esito || '—'}${res.tecnologia ? '  ·  ' + res.tecnologia : ''}`, M + 4, y + 7.4);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  doc.text('Fonte: sito TIM', R - 4, y + 7.4, { align: 'right' });
  y += 18;
  titoloGruppo(doc, y, 'DETTAGLIO');
  y += 11;
  const voci = [
    ['Verdetto', res.raw],
    ['Tecnologia', res.tecnologia],
    ['Download', fmtVel(res.down)],
    ['Upload', fmtVel(res.up)],
    ['Latenza', res.latenza != null && res.latenza !== '' ? `${res.latenza} ms` : null],
    ['Indirizzo', res.indirizzo_norm],
  ].filter(([, v]) => v != null && v !== '');
  voci.forEach(([l, v]) => {
    if (y > 282) { doc.addPage(); y = 20; }
    riga(doc, y, l, v);
    y += 7;
  });
  if (res.tecnologia === 'FWA' && res.down == null && res.up == null) {
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(107, 116, 134);
    doc.text("Per l'FWA il sito TIM non pubblica le velocità (mostra solo la latenza).", M, y + 3);
  }
  return chiudi(doc, 'copertura-tim.pdf');
}

/** Scarica un File generato (blob URL con revoca ritardata). */
export function scaricaFile(file) {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url; a.download = file.name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
